'use strict'

import Helper from '@/utils/helper'
import Ticket from '@/app/service/api/model/ticket'

class ClientQueueItem {
  constructor ({ title, tickets }) {
    this.title = Helper.getValue(title)
    this.tickets = Helper.isDefined(tickets) ? tickets.map((ticket) => new Ticket(ticket)) : []
  }

  getTitle () {
    return this.title
  }

  getTickets () {
    return this.tickets
  }

  isExistTickets () {
    return this.tickets.length > 0
  }

  toString () {
    return 'ClientQueueItem{' +
      'title=' + '\'' + this.title + '\'' +
      ', tickets=' + '\'' + this.tickets + '\'' +
      '}'
  }
}

export default ClientQueueItem
